export default __webpack_public_path__ + "static/media/99@3x.b2759cc0.png";